import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import topBanner from 'domains/referrals/assets/top-banner.webp';
import { LoggingInGuard } from 'modules/auth/components/LoggingInGuard';
import { Page } from 'modules/layout/components/Page';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { preloadImage } from 'modules/common/utils/preloadImage';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';

const ReferralsPage = loadable(
  async () => {
    const module = await import('./ReferralsPage');

    await preloadImage({ src: topBanner });

    return module.ReferralsPage;
  },
  { fallback: <OverlaySpinner /> },
);

const chainsPath = chainsRoutesConfig.chains.generatePath();

export const ReferralsPageContainer = () => {
  return (
    <Page>
      <NoSSRGuard>
        <LoggingInGuard fallback={<Navigate to={chainsPath} />}>
          <ReferralsPage />
        </LoggingInGuard>
      </NoSSRGuard>
    </Page>
  );
};
